import React from "react";
import { useTranslation } from "react-i18next";
import {
  EnergyBanner1,
  EnergyBanner2,
  EnergyDesc1,
  EnergyDesc2,
  NutirentsBodyNeed,
  EnergyDesc3,
  EnergyDesc4,
  Magnesium,
  MagnesiumDesc,
  MagnesiumDetail1,
  MagnesiumDetail2,
  VitaminB12,
  VitaminB12Desc,
  VitaminB12Detail1,
  VitaminB12Detail2,
  Iron,
  IronDesc,
  IronDetail1,
  IronDetail2,
  VitaminD,
  VitaminDDesc,
  VitaminDDetail1,
  VitaminDDetail2,
  FormulatedByExperts,
  SupportEnergy,
} from "../../Constants";
import ExpertSection from "../Customer/components/ExpertSection";
import MillionCombinations from "../Home/MillionCombinations";
import HighStandards from "../Home/HighStandards";
import ReviewsOverlay from "../Reviews";
import Unique from "../Home/Unique";
import MagnesiumImg from "../../assets/focusareas/magnesium-microgranules.webp";
import VitaminB12Img from "../../assets/focusareas/vitamin-B12-microgranules.webp";
import VitaminDImg from "../../assets/focusareas/vitamin-D3-microgranules.webp";
import IronImg from "../../assets/focusareas/iron-microgranules.webp";
import BannerMobile from "./components/BannerMobile";
import Description from "./components/Description";
import NutrientsMobile from "./components/NutrientsMobile";
import News from "./components/News";
import GlutenFree from "./components/GlutenFree";
import Banner from "./components/Banner";
import Nutrients from "./components/Nutrients";
import UniqueWeb from "./components/UniqueWeb";
import GlutenFreeWeb from "./components/GlutenFreeWeb";

const Energy = () => {
  const { t } = useTranslation();

  const INGREDIENTS_DATA = [
    {
      title: t(Magnesium),
      desc: t(MagnesiumDesc),
      img: MagnesiumImg,
      details1: t(MagnesiumDetail1),
      details2: t(MagnesiumDetail2),
    },
    {
      title: t(VitaminB12),
      desc: t(VitaminB12Desc),
      img: VitaminB12Img,
      details1: t(VitaminB12Detail1),
      details2: t(VitaminB12Detail2),
    },
    {
      title: t(Iron),
      desc: t(IronDesc),
      img: IronImg,
      details1: t(IronDetail1),
      details2: t(IronDetail2),
    },
    {
      title: t(VitaminD),
      desc: t(VitaminDDesc),
      img: VitaminDImg,
      details1: t(VitaminDDetail1),
      details2: t(VitaminDDetail2),
    },
  ];

  return (
    <div>
      <BannerMobile heading1={t(EnergyBanner1)} heading2={t(EnergyBanner2)} />
      <div className="t-hidden md:t-block">
        <Banner
          heading1={t(EnergyBanner1)}
          heading2={t(EnergyBanner2)}
          desc1={t(EnergyDesc1)}
          desc2={t(EnergyDesc2)}
        />
        <Nutrients
          heading={t(NutirentsBodyNeed)}
          desc1={t(EnergyDesc3)}
          desc2={t(EnergyDesc4)}
          data={INGREDIENTS_DATA}
        />

        <UniqueWeb />
        <GlutenFreeWeb />
      </div>
      <Description desc1={t(EnergyDesc1)} desc2={t(EnergyDesc2)} />
      <NutrientsMobile
        heading={t(NutirentsBodyNeed)}
        desc1={t(EnergyDesc3)}
        desc2={t(EnergyDesc4)}
        data={INGREDIENTS_DATA}
      />
      <div className="md:t-hidden">
        <Unique isFocusArea heading={t(SupportEnergy)} />
      </div>
      <div>
        <MillionCombinations slug="/quiz" isFocusArea />
      </div>
      <section className="md:t-hidden t-flex t-items-center t-justify-center t-py-2 t-bg-gray-100 t-h-10">
        <ReviewsOverlay totalReviews={55} averageReviews={4.92} />
      </section>
      <div className="t-flex t-flex-col t-gap-4 t-p-4 t-max-w-[800px] !t-mx-auto">
        <h1 className="t-text-[24px] t-text-center">
          {t(FormulatedByExperts)}
        </h1>
        <ExpertSection />
      </div>
      <div>
        <HighStandards />
      </div>
      <GlutenFree />
      <News />
    </div>
  );
};

export default Energy;
